import reportOverviewRedux from 'Modules/reports/views/overview/redux/reducer';
import reportExportHistoryRedux from 'Modules/reports/.components/reportExportHistory/redux/reducer';


//export redux objects
export default {
	reportOverviewRedux,
	reportExportHistoryRedux,
};